@if (ready) {
<div class="flex h-screen bg-[var(--bg-main)] p-4 gap-4 overflow-hidden">
  <aside
    class="relative flex flex-col bg-[var(--surface)] rounded-2xl shadow-sm border border-[var(--border)] transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] z-[500]"
    [ngClass]="isCollapsed ? 'w-20' : 'w-64'"
  >
    <div class="p-4 mb-2 flex items-center h-20 relative">
      <div class="flex items-center gap-3">
        <div
          class="h-10 w-10 shrink-0 bg-[var(--primary)] flex items-center justify-center shadow-lg shadow-[var(--primary-soft)]"
        >
          <img
            src="https://ts-space.sgp1.digitaloceanspaces.com/uploads/lottery/admin/image/ae09640b-f4dd-4d6e-89ed-727834ba8d1e-logo.png"
            alt="L"
            class="h-7 w-7 object-contain"
          />
        </div>

        <div
          class="flex flex-col transition-all duration-300 origin-left"
          [ngClass]="isCollapsed ? 'opacity-0 scale-0 w-0' : 'opacity-100 scale-100 w-auto'"
        >
          <span class="font-bold text-lg leading-tight whitespace-nowrap text-[var(--text)]">{{
            'admin.lottery' | translate
          }}</span>
          <span
            class="text-[10px] uppercase tracking-widest font-semibold whitespace-nowrap text-[var(--primary)]"
            >{{ 'admin.management' | translate }}</span
          >
        </div>
      </div>

      <button
        (click)="toggleSideBar()"
        class="absolute -right-3 top-1/2 -translate-y-1/2 h-6 w-6 bg-[var(--surface)] border border-[var(--border)] rounded-full shadow-md grid place-items-center hover:text-[var(--primary)] transition-all z-1000"
      >
        <i
          class="fa-solid text-[10px] transition-transform duration-300"
          [ngClass]="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"
        ></i>
      </button>
    </div>

    <nav
      class="flex-1 px-3 space-y-2 overflow-y-auto overflow-x-visible custom-scrollbar"
      [ngClass]="{ '!overflow-visible': isCollapsed }"
    >
      @for (item of navItems; track item.path) {
      <a
        [routerLink]="item.path"
        routerLinkActive="active"
        class="nav-link group relative flex items-center h-12 rounded-xl transition-all duration-200 text-[var(--text-2)] hover:bg-[var(--surface-muted)]"
      >
        <div class="min-w-[56px] flex justify-center">
          <i class="fa-solid text-lg" [ngClass]="item.icon"></i>
        </div>

        <span
          class="font-medium whitespace-nowrap transition-all duration-300"
          [ngClass]="isCollapsed ? 'opacity-0 w-0 overflow-hidden' : 'opacity-100 w-auto'"
        >
          {{ 'admin.' + item.path | translate }}
        </span>

        @if (isCollapsed) {
        <div
          class="absolute left-full ml-5 px-3 py-2 bg-gray-900 text-white text-xs font-semibold rounded-lg opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 pointer-events-none transition-all duration-300 whitespace-nowrap z-[100] shadow-xl"
        >
          <div
            class="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45"
          ></div>
          {{ 'admin.' + item.path | translate }}
        </div>
        }
      </a>
      }
    </nav>

    <div class="p-3 mt-auto border-t border-[var(--border)]/50">
      <button
        (click)="signOut()"
        class="group relative w-full flex items-center h-12 rounded-xl text-red-500 hover:bg-red-50 transition-colors"
      >
        <div class="min-w-[56px] flex justify-center">
          <i
            class="fa-solid fa-arrow-right-from-bracket group-hover:-translate-x-1 transition-transform"
          ></i>
        </div>
        <span
          class="font-semibold whitespace-nowrap transition-all duration-300 overflow-hidden"
          [ngClass]="isCollapsed ? 'opacity-0 w-0' : 'opacity-100 w-auto'"
        >
          {{ 'admin.signOut' | translate }}
        </span>

        @if (isCollapsed) {
        <div
          class="absolute left-full ml-5 px-3 py-2 bg-red-600 text-white text-xs font-semibold rounded-lg opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 pointer-events-none transition-all duration-300 whitespace-nowrap z-[100] shadow-xl"
        >
          <div class="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-red-600 rotate-45"></div>
          {{ 'admin.signOut' | translate }}
        </div>
        }
      </button>
    </div>
  </aside>

  <main class="flex-1 flex flex-col min-w-0 overflow-y-auto custom-scrollbar">

    <app-alert></app-alert>
    <app-order-notification></app-order-notification>
    <router-outlet></router-outlet>
  </main>
</div>

@if (showLogoutConfirm) {
<div class="fixed inset-0 z-[10000] flex items-center justify-center p-4">
  <div
    class="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300"
    (click)="cancelSignOut()"
  ></div>

  <div
    class="relative bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl w-full max-w-[380px] overflow-hidden animate-scaleIn p-6 flex flex-col items-center gap-6 border border-white/20"
  >
    <div
      class="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center text-red-500 shadow-inner"
    >
      <i class="fa-solid fa-arrow-right-from-bracket text-2xl"></i>
    </div>

    <div class="text-center">
      <h3 class="text-xl font-bold text-gray-900 mb-2">{{ 'admin.signOutConfirm' | translate }}</h3>
      <p class="text-gray-500">{{ 'admin.signOutMsg' | translate }}</p>
    </div>

    <div class="flex gap-3 w-full">
      <button
        (click)="cancelSignOut()"
        class="flex-1 px-4 py-3 rounded-xl border border-gray-200 text-gray-600 font-semibold hover:bg-gray-50 transition-all duration-200"
      >
        {{ 'admin.cancel' | translate }}
      </button>
      <button
        (click)="confirmSignOut()"
        class="flex-1 px-4 py-3 rounded-xl bg-red-500 text-white font-semibold hover:bg-red-600 shadow-lg shadow-red-200 transition-all duration-200 flex items-center justify-center gap-2 active:scale-95"
      >
        <span>{{ 'admin.signOut' | translate }}</span>
      </button>
    </div>
  </div>
</div>
} }
